export const SET_HORIZONTAL_SELECTED_THEMATICS_SELECTION_OPTION = 'SET_HORIZONTAL_SELECTED_THEMATICS_SELECTION_OPTION';

export const setHorizontalSelectedThematicSelectionOption = (horizontalSelectedThematicSelectionOption: any) => ({
  type: SET_HORIZONTAL_SELECTED_THEMATICS_SELECTION_OPTION,
  data: horizontalSelectedThematicSelectionOption,
});
